import React, { useContext, useEffect, useRef, useState } from 'react';
import { AdminContext, useGetState } from '../../hooks';
import BoatMap from '../admin2/BoatMap';
import axios from 'axios';

function InsertPassword({setPaths, setMarkers}) {
    let [p, setP] = useState('');
    let [loading, setLoading] = useState(false);
    let [error, setError] = useState(false);
    let ref = useRef();

    useEffect(()=>{
        ref.current.focus();
    }, [])

    async function submit() {
        setLoading(true);
        let {data} = await axios.post('/api/gps/paths', {p});
        if (data.error) {
            setError(true);
            setLoading(false);
            setTimeout(() => {
                ref.current.focus();
                ref.current.select();
            }, 0);
        } else {
            setPaths(data.paths);
            setMarkers(data.markers);
            console.log(data);
            setLoading(false);
        }
    }

    return <div className="boatPassword">
        <div className="form">
            <h1>Password:</h1>
            <input
                type="text"
                value={p}
                onChange={e => {
                    setP(e.target.value);
                    setError(false);
                }}
                onKeyDown={e => {
                    if (e.key == "Enter") {
                        e.preventDefault();
                        submit()
                    }
                }}
                disabled={loading}
                ref={ref}
            ></input>
            <br/>
            <div className="button">
                <button onClick={submit} disabled={loading}>Submit</button>
            </div>
            <div className="error">
                {error ? "Incorrect password!" : null}
            </div>
        </div>
        
    </div>
}

export default function BoatTracker({ }) {
    let [paths, setPaths] = useState();
    let [markers, setMarkers] = useState();
    
    let { setBackgroundColour } = useContext(AdminContext);

    useEffect(() => {
        setBackgroundColour("White");
        return () => setBackgroundColour(false);
    }, [])

    if (!paths) return <InsertPassword setPaths={setPaths} setMarkers={setMarkers}/>

    return <div className="BoatTracker">
        <BoatMap paths={paths} markers={markers}/>
    </div>
}